import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";

import "./Spinner.scss";

const Spinner = ({
  size = 32,
  line = 4,
  lineColor = COLOR_PRIMARY,
  borderColor = "#eee",
}: {
  size?: number;
  line?: number;
  lineColor?: string;
  borderColor?: string;
}) => {
  return (
    <div
      className="spinner"
      style={{
        width: size,
        height: size,
        border: `${line}px solid ${borderColor}`,
        borderTop: `${line}px solid ${lineColor}`,
        borderRadius: "50%",
      }}
    ></div>
  );
};

export default Spinner;
